
import { defineComponent, PropType } from '@vue/composition-api';
import { MyBet, CashoutBet } from '../../../../../types/sport';
import BetStatusIcon from './BetStatusIcon.vue';

export default defineComponent({
  name: 'BetItem',
  components: {
    BetStatusIcon
  },
  props: {
    bet: {
      type: Object as PropType<MyBet | CashoutBet>,
      required: true
    }
  },
  computed: {
    getBetCode(): string {
      return (this.bet as any).betCode || (this.bet as any).code || '';
    },
    getWinningDisplay(): string {
      const bet = this.bet;
      if (bet.winning_real) {
        return `${bet.currencySymbol} ${this.formatAmount(bet.winning_real)}`;
      }
      return this.getWinning(bet);
    }
  },
  methods: {
    t(key: string): string {
      return this.$t(key) as string;
    },
    formatDate(date: string | number): string {
      return new Date(date).toLocaleString();
    },
    formatAmount(amount: number | string): string {
      return parseFloat(String(amount)).toFixed(2);
    },
    getWinning(bet: MyBet | CashoutBet): string {
      const betAny = bet as any;
      const currencySymbol = betAny.currencySymbol || '';

      switch (bet.type) {
        case 'single':
        case 'multiple':
          const multipleDetail = betAny._multiple_detail;
          if (multipleDetail && multipleDetail.winning_total !== undefined) {
            return `${currencySymbol} ${this.formatAmount(
              multipleDetail.winning_total
            )}`;
          }
          return `${currencySymbol} 0.00`;
        case 'integral':
          const integralDetail = betAny._integral_detail;
          if (
            integralDetail &&
            integralDetail.winning_total_max !== undefined
          ) {
            return `${currencySymbol} ${this.formatAmount(
              integralDetail.winning_total_max
            )}`;
          }
          return `${currencySymbol} 0.00`;
        case 'system':
          const systemDetail = betAny._system_detail;
          if (systemDetail && systemDetail.winning_all_total !== undefined) {
            return `${currencySymbol} ${this.formatAmount(
              systemDetail.winning_all_total
            )}`;
          }
          return `${currencySymbol} 0.00`;
        default:
          return `${currencySymbol} 0.00`;
      }
    }
  }
});
